<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Birthdays</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Birthdays</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <v-data-table
                  :headers="headers"
                  :items="sortBirthdays"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link
                        :to="{
                          name: 'employeedetail',
                          params: { id: item.id }
                        }"
                        class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.passportPhoto"
                          width="38"
                          v-if="item.passportPhoto"
                      /></router-link>
                      <router-link
                        :to="{
                          name: 'employeedetail',
                          params: { id: item.id }
                        }"
                        >{{ `${item.firstName} ${item.lastName}` }}</router-link
                      >
                    </h2>
                  </template>

                  <template v-slot:[`item.phone`]="{ item }">
                    {{ item.phone }}
                  </template>
                  <template v-slot:[`item.birthday`]="{ item }">
                    {{
                      `${getBirthday(item.birthday)} ${new Date(
                        item.birthday
                      ).getDate()}`
                    }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "Phone Number", value: "phone" },
        { text: "Birthday", value: "birthday" }
      ],

      loading: false,
      birthdays: []
    };
  },

  computed: {
    sortBirthdays: function() {
      function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
      }

      return this.birthdays.sort(compare);
    }
  },

  methods: {
    getUpcomingBirthday() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getUpcomingBirthday(unit.id).then(o => {
        this.birthdays = o;
        console.log(this.birthdays);
      });
    },

    getBirthday(dateOfbirth) {
      console.log(dateOfbirth);
      var currentDate = new Date(dateOfbirth).getDate();
      var currentMonth = new Date(dateOfbirth).getMonth();
      var currentYear = new Date().getFullYear();

      var birthday = new Date(currentYear, currentMonth, currentDate);
      console.log(currentMonth);
      var dayNum = birthday.getMonth();
      console.log(currentDate);
      switch (dayNum) {
        case 0:
          return "January";
        case 1:
          return "Feburary";
        case 2:
          return "March";
        case 3:
          return "April";
        case 4:
          return "May";
        case 5:
          return "June";
        case 6:
          return "July";
        case 7:
          return "August";
        case 8:
          return "September";
        case 9:
          return "October";
        case 10:
          return "November";
        case 11:
          return "December";
      }
    }
  },

  mounted() {
    this.getUpcomingBirthday();
  },
  name: "birthdays"
};
</script>



// WEBPACK FOOTER //
// src/components/miscs/birthdays.vue